import { combineReducers } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import { cardinalApiRtk } from './services/auth.api'
import { app, persistConfig } from './app'
import { practitionerApiRtk } from './api/practitionerApi'
import { userApiRtk } from './api/userApi'
import { patientApiRtk } from './api/patientApi'
import { deviceApiRtk } from './api/deviceApi'
import { contactApiRtk } from './api/contactApi'
import { healthElementApiRtk } from './api/healthElementApi'
import { formApiRtk } from './api/formApi'
import { msgGwApiRtk } from './api/notificationService'
import { bingliApiRtk } from './api/bingliApi'
import { pdfReportApiRtk } from './api/pdfReportApi'
import { codeApiRtk } from './api/codeApi'
import { interopApiRtk } from './api/interopApi'
import { exportApiRtk } from './api/exportApi'
import { formTemplateApiRtk } from './api/formTemplateApi'

export const appReducer = combineReducers({
  app: app.reducer,
  cardinalApi: cardinalApiRtk.reducer,
  codeApi: codeApiRtk.reducer,
  interopApi: interopApiRtk.reducer,
  practitionerApi: practitionerApiRtk.reducer,
  userApi: userApiRtk.reducer,
  deviceApi: deviceApiRtk.reducer,
  patientApi: patientApiRtk.reducer,
  contactApi: contactApiRtk.reducer,
  formApi: formApiRtk.reducer,
  formTemplateApi: formTemplateApiRtk.reducer,
  healthElementApi: healthElementApiRtk.reducer,
  bingliApi: bingliApiRtk.reducer,
  pdfReportApi: pdfReportApiRtk.reducer,
  exportApi: exportApiRtk.reducer,
  msgGwApi: msgGwApiRtk.reducer,
})

export const persistedReducer = persistReducer(persistConfig, appReducer)

export type AppState = ReturnType<typeof appReducer>
